module.exports = __webpack_public_path__ + "img/sake_bin_list.830f564c.png";